import React, { useState } from "react";
import { NavLink,Link } from "react-router-dom";
import "./navbar.css";
import { LogoColoured } from "../../assets";
import { navigationLinks } from "./../../constants/links";
import { FaAlignRight } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";

const Navbar = () => {
  const [isNavToggle, setIsNavToggle] = useState(false);

  const toggle = () => setIsNavToggle(!isNavToggle);
  const hide = () => setIsNavToggle(false);
  const show = () => setIsNavToggle(true);

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <Link to="/" className="nav__logo">
            <img src={LogoColoured} alt="Logo" className="logo" />
          </Link>
          
          <ul
            className={`nav__items ${isNavToggle ? "show__nav" : "hide__nav"}`}
          >
            {navigationLinks.map(({ name, url }, index) => {
              return (
                <li key={index}>
                  <NavLink
                    to={url}
                    className={({ isActive }) => (isActive ? "active" : "")}
                    onClick={toggle}
                    onBlur={hide}
                    onFocus={show}
                  >
                    {name}
                  </NavLink>
                </li>
              );
            })}
            <NavLink to={"/donate"} className="donateNavBtn">
              Donate
            </NavLink>
          </ul>

          <button
            id="open__nav-btn"
            onClick={() => setIsNavToggle(!isNavToggle)}
          >
            {isNavToggle ? <MdOutlineClose /> : <FaAlignRight />}
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
